
<template>
  <div class="czrz">
    <div class="u-form">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          操作日志
        </h4>
      </template>
      <car-form @submit="submit" :showformitem="formitem" :default-form-value="defaultFormValue">
      </car-form>
    </div>

    <hy-data-table
      v-model="loading"
      height="94%"
      ref="dataTable"
      @find-page="findPage"
      is-all-handle
      :data="dataTable.list"
      :columns="dataTable.columns"
      :extend-buttons="dataTable.buttons"
      :show-batch-delete="true"
      :show-operation="true"
      size="medium"
      :paging="dataTable.paging"
      :extend-but-widht="180"
    ></hy-data-table>
  </div>
</template>

<script>
import carForm from "@/components/form/carForm.vue";
import hyDataTable from "@/components/HyDataTable.vue";
import { mapState } from "vuex";
export default {
  components: {
    carForm,
    hyDataTable,
  },
  computed: {
    ...mapState({
      boxDetailRerefsh: (state) => state.detail.boxDetailRerefsh,
    }),
  },
  data() {
    const typeTime = {
      tableName: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd")
    };
    return {
      saveAddTemplate: {},
      form: {},
      height: "",
      formitem: [
        "tableName",
        "logTime",
        "coId",
        "creator"
      ],
      curDate:"",
      loading: false, // 是否加载的标识
      defaultFormValue: {
        tableName: Object.values(typeTime),
      },
      pageRow: 10,
      pageIndex: 1,
      detailList: [
      ], //详情修改显示的项目
      dataTable: {
        list: {
        },
        columns: [
          { prop: "coName", label: "所属企业", minWidth: 140 },
          { prop: "module", label: "功能模块", minWidth: 100 },
          { prop: "title", label: "操作标题", minWidth: 150 },
          { prop: "method", label: "请求方式", minWidth: 60 },
          { prop: "content", label: "请求参数", minWidth: 100 },
          { prop: "creator", label: "操作人", minWidth: 70 },
          { prop: "createDate", label: "操作时间", minWidth: 120 },
        ],
        buttons: [
          // {
          //   label: "详情",
          //   click: "detail-handle",
          //   perms: 100103,
          //   type: "primary",
          // }
        ],
        paging: {
          pageIndex: 1, // 表格分页信息
          pageRow: 10,
          total: 0,
        },
      },
    };
  },
  methods: {
    submit(form) {
      if(form.tableName == ""){
        return  this.$message.error("日志日期不能为空!")
      }
      let curDate = form.tableName.replace(/-/g, '');
      if(form.logTime != undefined && form.logTime != ''){
          this.form.beginTime = form.tableName +' '+ form.logTime[0];
          this.form.endTime = form.tableName +' '+ form.logTime[1];
      }else{
          this.form.beginTime = '';
          this.form.endTime = '';
      }
      this.form.tableName = curDate
      this.pageIndex = 1;
      this.dataTable.paging.pageIndex = 1;
      this.form.coId = form.CoId;
      this.form.creator = form.creator;
      this.getData();
    },
    findPage(res1) {
      if (!this.form.tableName) {
        this.getCurDate();
      }
      this.pageIndex = res1.pageRequest.pageIndex;
      this.pageRow = res1.pageRequest.pageRow || this.pageRow;
      this.getData();
    },
    
    //详情
    detailHandle(res) {
      const data = res.row;
      this.$http.GET_tollgateInfo({ paramsID: "/" + data.tid }).then((response) => {
        console.log("详情接口结果", response);
        this.$store.commit("boxDetail", {
          data: response.data,
          title: "详情",
          api: "POST_tollgateUpdata",
          uploadImgApi: this.$apis.POST_tollgateImg,
          sort: this.detailList,
        });
      });
    },
    getCurDate(){
      let year = new Date().getFullYear();
      let month = new Date().getMonth() +1;
      let day = new Date().getDate();
      if(month < 10){
        month = "0"+month;
      }
      if(day < 10){
        day = "0"+day;
      }
      this.curDate = year + '' + month + '' + day;
      this.form.tableName = this.curDate;
    },
    //数据列表
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      let arr = [];
      this.$http
        .POST_getLogList(this.form)
        .then((response) => {
          console.log("列表结果", response);
          this.dataTable.paging.total = response.total;
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              const result = this.$myPlug.sortName2cn(response.data[i]);
              arr.push(result);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: this.pageIndex,
            data: [],
          };
          this.$set(this.dataTable.list, "data", arr);
          this.saveAddTemplate = JSON.parse(JSON.stringify(this.dataTable.list.data[0]));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //列表字典转换处理
    dictionaryChage(val, option) {
      let data = "";
      for (let item of option) {
        if (item.code == val) {
          data = item.name;
          break;
        } else {
          data = val;
        }
      }
      return data;
    },
  },
  mounted() {
    //this.getData()
  },
  created() {
    const obj = {};
  },
  watch: {
    boxDetailRerefsh(nval) {
      if (nval) this.getData();
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/xtgl/czrz.vue